import React from 'react'
import { J2Add, J2Subtract } from '@e3dc-react/icons'
import { IconButton, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import QuantityInput from './QuantityInput'

interface ButtonQuantityProps {
  quantity: number
  maxQuantity?: number
  minQuantity?: number
  isLoading?: boolean
  disabled?: boolean
  onQuantityDecrease: () => void
  onQuantityIncrease: () => void
  onQuantityChange?: (value: number) => void
}

const useStyles = makeStyles()(theme => ({
  numCounter: {
    display: 'flex',
    alignItems: 'center',
  },
  iconButtonBackwards: {
    padding: 0,
    background: theme.palette.grey.grey02,
    color: theme.palette.primary.contrastText,
    width: 32,
    height: 32,
    borderRadius: theme.shape.borderRadius,
  },
  iconButton: {
    padding: 0,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: 32,
    height: 32,
    borderRadius: theme.shape.borderRadius,
  },
  buttonContainer: {
    padding: `0 ${theme.spacing(1)}`,
  },
}))

/*
 * This component shows button quantity for products
 */
const ButtonQuantity: React.FC<ButtonQuantityProps> = ({
  quantity,
  isLoading,
  maxQuantity,
  minQuantity = 0,
  disabled = false,
  onQuantityDecrease,
  onQuantityIncrease,
  onQuantityChange,
}) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.numCounter}>
      <IconButton className={classes.buttonContainer} disabled={quantity <= minQuantity || isLoading} onClick={onQuantityDecrease}>
        <J2Subtract className={classes.iconButtonBackwards} />
      </IconButton>
      <QuantityInput
        disabled={isLoading || disabled}
        quantity={quantity}
        minQuantity={minQuantity}
        maxQuantity={maxQuantity}
        onQuantityChange={onQuantityChange}
      />
      <IconButton
        className={classes.buttonContainer}
        disabled={(maxQuantity !== undefined && quantity >= maxQuantity) || isLoading}
        onClick={onQuantityIncrease}
      >
        <J2Add className={classes.iconButton} />
      </IconButton>
    </Box>
  )
}

export default ButtonQuantity
